module.exports = __webpack_public_path__ + "static/media/24UHCHR19.63e913f6.jpg";